module.exports = {"key":"hello dutch","submit":"Overslaan, volgende vraag!","hide":"Verberg dit","skip":"Overslaan, volgende vraag","placeholder":"Omschrijf hoe je je hierover voelt..."}


//////////////////
// WEBPACK FOOTER
// ./src/translations/nl.json
// module id = 446
// module chunks = 0